import Box from "ds/components/Box";
import BadgeNext from "ds/components/BadgeNext";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import Link from "ds/components/Link";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { CellComponentProps } from "../types";

type UserRolesListItemNameCellProps = CellComponentProps;

const UserRolesListItemNameCell = ({ roleBinding }: UserRolesListItemNameCellProps) => {
  const roleUrl = `/settings/role/${roleBinding.role.id}`;

  return (
    <Box fullWidth gap="large">
      {roleBinding.role.isSystem ? (
        <>
          <TextEllipsis tooltip={roleBinding.role.name} tooltipWidthMode="maxWidthSm">
            {(props) => (
              <Typography {...props} tag="p" variant="p-body3">
                {roleBinding.role.name}
              </Typography>
            )}
          </TextEllipsis>

          <BadgeNext type="strong" variant="blue" text="SYSTEM" />
        </>
      ) : (
        <Link
          analyticsPage={AnalyticsPageOrganization.OrganizationUserRoles}
          analyticsTitle="Role Name Clicked"
          analyticsProps={{
            roleName: roleBinding.role.name,
          }}
          size="small"
          variant="secondary"
          href={roleUrl}
        >
          {roleBinding.role.name}
        </Link>
      )}
    </Box>
  );
};

export default UserRolesListItemNameCell;
